var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 8.99999C7.45837 8.99999 7.85074 8.8368 8.17712 8.51041C8.50351 8.18402 8.66671 7.79166 8.66671 7.33332C8.66671 6.87499 8.50351 6.48263 8.17712 6.15624C7.85074 5.82985 7.45837 5.66666 7.00004 5.66666C6.54171 5.66666 6.14935 5.82985 5.82296 6.15624C5.49657 6.48263 5.33337 6.87499 5.33337 7.33332C5.33337 7.79166 5.49657 8.18402 5.82296 8.51041C6.14935 8.8368 6.54171 8.99999 7.00004 8.99999ZM7.00004 15.125C8.69448 13.5694 9.95143 12.1562 10.7709 10.8854C11.5903 9.61457 12 8.4861 12 7.49999C12 5.9861 11.5174 4.74652 10.5521 3.78124C9.58685 2.81596 8.40282 2.33332 7.00004 2.33332C5.59726 2.33332 4.41324 2.81596 3.44796 3.78124C2.48268 4.74652 2.00004 5.9861 2.00004 7.49999C2.00004 8.4861 2.40976 9.61457 3.22921 10.8854C4.04865 12.1562 5.3056 13.5694 7.00004 15.125ZM7.00004 17.3333C4.76393 15.4305 3.09379 13.6632 1.98962 12.0312C0.885457 10.3993 0.333374 8.88888 0.333374 7.49999C0.333374 5.41666 1.00351 3.75693 2.34379 2.52082C3.68407 1.28471 5.23615 0.666656 7.00004 0.666656C8.76393 0.666656 10.316 1.28471 11.6563 2.52082C12.9966 3.75693 13.6667 5.41666 13.6667 7.49999C13.6667 8.88888 13.1146 10.3993 12.0105 12.0312C10.9063 13.6632 9.23615 15.4305 7.00004 17.3333Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.4b9aa38ec498a7fa81b37da64b3e825c.svg";
export { ForwardRef as ReactComponent };